import api from '@/services/Api';

export class RoleService {
  async getRoleList() {
    const response = await api.get('/distributor/role/all')
    return response.data
  }
}

export default new RoleService()
